import { render, staticRenderFns } from "./MoneyConfigManage.vue?vue&type=template&id=d46ccb42&"
import script from "./MoneyConfigManage.vue?vue&type=script&lang=js&"
export * from "./MoneyConfigManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports